import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const convertElementToPDF = async (
  elementRef: React.RefObject<HTMLElement>
) => {
  if (elementRef.current !== null) {
    const element = elementRef.current;

    // Convert the React element to an image using html2canvas
    const canvas = await html2canvas(element);

    // Create a new jsPDF instance
    const doc = new jsPDF({
      format: "a4",
    });

    // Calculate the width and height of the PDF page
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Calculate the width and height of the image while maintaining the aspect ratio
    const imageRatio = canvas.width / canvas.height;
    let imageWidth = pageWidth;
    let imageHeight = imageWidth / imageRatio;

    // Check if the image height exceeds the page height and scale it down if necessary
    if (imageHeight > pageHeight) {
      imageHeight = pageHeight;
      imageWidth = imageHeight * imageRatio;
    }

    // Add the image to the PDF
    doc.addImage(
      canvas.toDataURL("image/jpeg"),
      "JPEG",
      0,
      0,
      imageWidth,
      imageHeight
    );

    // Save the PDF
    doc.save("downloaded_element.pdf");
  }
};

export default convertElementToPDF;
